const foundation = {
  color: {
    base: {
      black: '#000000',
      white: '#ffffff',
      transparent: '#ffffff00',
    },
    alphaBlack: {
      '5': '#1316190d',
      '10': '#1316191a',
      '15': '#13161926',
      '20': '#13161933',
      '25': '#13161940',
      '30': '#1316194d',
      '35': '#13161959',
      '40': '#13161966',
      '45': '#13161973',
      '50': '#13161980',
      '55': '#1316198c',
      '60': '#13161999',
      '65': '#131619a6',
      '70': '#131619b3',
      '75': '#131619bf',
      '80': '#131619cc',
      '85': '#131619d9',
      '90': '#131619e6',
      '95': '#131619f2',
    },
    alphaWhite: {
      '5': '#ffffff0d',
      '10': '#ffffff1a',
      '15': '#ffffff26',
      '20': '#ffffff33',
      '25': '#ffffff40',
      '30': '#ffffff4d',
      '35': '#ffffff59',
      '40': '#ffffff66',
      '45': '#ffffff73',
      '50': '#ffffff80',
      '55': '#ffffff8c',
      '60': '#ffffff99',
      '65': '#ffffffa6',
      '70': '#ffffffb3',
      '75': '#ffffffbf',
      '80': '#ffffffcc',
      '85': '#ffffffd9',
      '90': '#ffffffe6',
      '95': '#fffffff2',
    },
    gray: {
      '25': '#f8f8f8',
      '50': '#ebebeb',
      '100': '#d6d6d6',
      '200': '#bebebe',
      '300': '#a3a3a3',
      '400': '#898989',
      '500': '#6c6c6c',
      '600': '#505050',
      '700': '#3a3a3a',
      '800': '#262626',
      '900': '#161616',
    },
    yellow: {
      '25': '#FFFCE5',
      '50': '#FFF7B1',
      '100': '#FDEF7F',
      '200': '#FAE000',
      '300': '#FFC800',
      '400': '#EAAF09',
      '500': '#C89612',
      '600': '#A77D15',
      '700': '#7D5E16',
      '800': '#423312',
      '900': '#1D1609',
    },
    coolGray: {
      '25': '#f9fafb',
      '50': '#f6f7f9',
      '100': '#ebeef2',
      '150': '#e3e7ed',
      '200': '#dce1e8',
      '250': '#c1c7d0',
      '300': '#a2aab6',
      '400': '#878e9b',
      '500': '#676f7d',
      '600': '#4b5361',
      '700': '#323841',
      '800': '#21262c',
      '900': '#131619',
    },
    blue: {
      '25': '#f6f8ff',
      '50': '#e4ebff',
      '100': '#c6d6ff',
      '200': '#9fbeff',
      '300': '#73a3ff',
      '400': '#3e85ff',
      '500': '#1a62e9',
      '600': '#1948b2',
      '700': '#1c347e',
      '800': '#1a2350',
      '900': '#131529',
    },
    green: {
      '25': '#f3faf5',
      '50': '#dbf1e1',
      '100': '#b2e1c1',
      '200': '#82ce9d',
      '300': '#4db779',
      '400': '#0e9d5a',
      '500': '#007c42',
      '600': '#005d31',
      '700': '#034424',
      '800': '#0c2c1a',
      '900': '#0b1910',
      alpha: {
        green: {
          '500': '#007c42e6',
        },
      },
    },
    red: {
      '25': '#fff7f5',
      '50': '#ffe7df',
      '100': '#ffcbbb',
      '200': '#ffa991',
      '300': '#ff7d61',
      '400': '#f94830',
      '500': '#da030ae6',
      '600': '#a60000',
      '700': '#7c0000',
      '800': '#510b00',
      '900': '#2c0d00',
      alpha: {
        red: {
          '500': '#da030ae6',
        },
      },
    },
    orange: {
      '25': '#fff6ef',
      '50': '#ffe7d3',
      '100': '#ffcca2',
      '200': '#ffac61',
      '300': '#ff8115',
      '400': '#de6603',
      '500': '#b05007',
      '600': '#823d0b',
      '700': '#5e2d0d',
      '800': '#3d1f0b',
      '900': '#221306',
    },
    purple: {
      '25': '#f9f6fe',
      '50': '#f1e8fc',
      '100': '#e1cefa',
      '200': '#cdb2f8',
      '300': '#b692f3',
      '400': '#9d6bff',
      '500': '#7646f8',
      '600': '#552ec9',
      '700': '#3e2293',
      '800': '#2b185b',
      '900': '#1b112e',
    },
    magenta: {
      '25': '#fff4f7',
      '50': '#ffe6ee',
      '100': '#ffc8d9',
      '200': '#ffa3c2',
      '300': '#ff76a6',
      '400': '#f44289',
      '500': '#d0146c',
      '600': '#9f0651',
      '700': '#730f3a',
      '800': '#461714',
      '900': '#270f17',
    },
    sky: {
      '25': '#f4f9fe',
      '50': '#deeefd',
      '100': '#b4dafb',
      '200': '#84c5f5',
      '300': '#4aace8',
      '400': '#0091cf',
      '500': '#0072a6',
      '600': '#00557c',
      '700': '#093e5a',
      '800': '#10293a',
      '900': '#0f171e',
    },
    teal: {
      '25': '#f4f9f9',
      '50': '#dcefee',
      '100': '#b5dedc',
      '200': '#8acac8',
      '300': '#57b2b0',
      '400': '#1c9896',
      '500': '#007977',
      '600': '#005a59',
      '700': '#024241',
      '800': '#0c2b2b',
      '900': '#0b1818',
    },
    background: {
      default: '#ffffff',
      neutral: '#f6f7f9',
      blanket: '#13161933',
    },
    surface: {
      default: '#ffffff',
      hover: '#f9fafb',
      press: '#f6f7f9',
      disabled: '#ffffff',
      neutral: {
        default: '#e3e7ed',
        hover: '#dce1e8',
        press: '#a2aab6',
        disabled: '#ebeef2',
        weak: {
          default: '#ebeef2',
          hover: '#e3e7ed',
          press: '#c1c7d0',
          disabled: '#f6f7f9',
          select: '#dce1e8',
        },
        weaker: {
          default: '#f6f7f9',
          hover: '#ebeef2',
          press: '#e3e7ed',
          disabled: '#f9fafb',
          select: '#ebeef2',
        },
        strong: {
          default: '#676f7d',
        },
        stronger: {
          default: '#323841',
        },
        strongest: {
          default: '#21262c',
          hover: '#323841',
          press: '#4b5361',
          disabled: '#21262c',
          select: '#323841',
        },
        select: '#c1c7d0',
        weakest: {
          default: '#f9fafb',
          hover: '#f6f7f9',
          press: '#ebeef2',
          select: '#f6f7f9',
          disabled: '#f9fafb',
        },
      },
      accent: {
        default: '#FAE000',
        strong: {
          default: '#FFC800',
        },
        weakest: {
          default: '#FFFCE5',
        },
        weaker: {
          default: '#FFF7B1',
          hover: '#FDEF7F',
          press: '#FFF7B1',
          select: '#FDEF7F',
        },
      },
      informative: {
        default: '#1a62e9',
        weak: {
          default: '#c6d6ff',
        },
        weakest: {
          default: '#f6f8ff',
          hover: '#e4ebff',
          press: '#c6d6ff',
          select: '#e4ebff',
        },
        weaker: {
          default: '#e4ebff',
          hover: '#c6d6ff',
          press: '#9fbeff',
          select: '#c6d6ff',
        },
      },
      success: {
        default: '#007c42',
        weaker: {
          default: '#dbf1e1',
          hover: '#b2e1c1',
          press: '#82ce9d',
          select: '#b2e1c1',
        },
        weakest: {
          default: '#f3faf5',
        },
        transparent: {
          default: '#007c42e6',
        },
      },
      danger: {
        default: '#da030ae6',
        weaker: {
          default: '#ffe7df',
          hover: '#ffcbbb',
          press: '#ffa991',
          disabled: '#fff7f5',
          select: '#ffcbbb',
        },
        weakest: {
          default: '#fff7f5',
          hover: '#ffe7df',
          press: '#ffcbbb',
          disabled: '#fff7f5',
          select: '#ffe7df',
        },
        transparent: {
          default: '#da030ae6',
        },
      },
      warning: {
        default: '#A77D15',
        weaker: {
          default: '#FFF7B1',
          hover: '#FDEF7F',
          press: '#FAE000',
          select: '#FDEF7F',
        },
        weakest: {
          default: '#FFFCE5',
        },
      },
      transparent: {
        hover: '#f9fafb',
        press: '#f6f7f9',
        disabled: '#ffffff',
        select: '#f9fafb',
        strongest: {
          default: '#131619d9',
        },
        strong: {
          hover: '#1316190d',
          press: '#1316191a',
        },
      },
      select: '#f9fafb',
      global: {
        default: '#21262c',
        hover: '#131619',
        press: '#000000',
        disabled: '#21262c',
        transparent: {
          weakest: {
            hover: '#13161966',
            press: '#13161999',
            select: '#1316194d',
          },
          strong: {
            hover: '#ffffff1a',
            press: '#ffffff33',
            select: '#ffffff1a',
          },
          weaker: {
            default: '#13161999',
            hover: '#131619cc',
            press: '#131619f2',
          },
        },
        strong: {
          default: '#131619',
          hover: '#000000',
          press: '#000000',
          select: '#ffffff',
        },
        select: '#131619',
        weak: {
          default: '#323841',
          hover: '#21262c',
          press: '#131619',
          select: '#ffffff',
        },
        weaker: {
          default: '#4b5361',
          hover: '#323841',
          press: '#21262c',
          select: '#ffffff',
        },
      },
    },
    text: {
      default: '#131619',
      disabled: '#c1c7d0',
      weak: {
        default: '#323841',
      },
      weaker: {
        default: '#676f7d',
      },
      weakest: {
        default: '#878e9b',
      },
      informative: {
        default: '#1a62e9',
        disabled: '#9fbeff',
        strong: {
          default: '#1948b2',
        },
      },
      success: {
        default: '#0e9d5a',
        disabled: '#82ce9d',
        strong: {
          default: '#007c42',
        },
      },
      danger: {
        default: '#da030ae6',
        disabled: '#ffa991',
        strong: {
          default: '#a60000',
          disabled: '#ff7d61',
        },
      },
      warning: {
        default: '#A77D15',
        strong: {
          default: '#7D5E16',
        },
      },
      interactive: {
        default: '#1a62e9',
        hover: '#1948b2',
        press: '#1c347e',
        disabled: '#9fbeff',
        select: '#1948b2',
        inverse: {
          default: '#73a3ff',
          hover: '#9fbeff',
          press: '#c6d6ff',
          select: '#9fbeff',
          disabled: '#1a62e9',
        },
      },
      inverse: {
        default: '#f9fafb',
        hover: '#dce1e8',
        press: '#c1c7d0',
        disabled: '#4b5361',
        select: '#dce1e8',
        weak: {
          default: '#ebeef2',
        },
        weaker: {
          default: '#dce1e8',
        },
        weakest: {
          default: '#a2aab6',
        },
      },
      accent: {
        default: '#FAE000',
        strong: {
          default: '#EAAF09',
        },
      },
      global: {
        default: '#dce1e8',
        weak: {
          default: '#a2aab6',
        },
        weakest: {
          default: '#878e9b',
        },
        disabled: '#4b5361',
        select: '#131619',
      },
    },
    icon: {
      global: {
        default: '#dce1e8',
        weak: {
          default: '#a2aab6',
        },
        weakest: {
          default: '#878e9b',
          hover: '#a2aab6',
          disabled: '#4b5361',
        },
        disabled: '#4b5361',
        select: '#131619',
        white: {
          default: '#ffffff',
        },
      },
      default: '#131619',
      disabled: '#c1c7d0',
      weak: {
        default: '#323841',
        hover: '#21262c',
      },
      weaker: {
        default: '#676f7d',
        hover: '#4b5361',
      },
      weakest: {
        default: '#878e9b',
        hover: '#4b5361',
      },
      informative: {
        default: '#1a62e9',
        disabled: '#9fbeff',
        strong: {
          default: '#1948b2',
        },
        weak: {
          default: '#3e85ff',
        },
      },
      success: {
        default: '#007c42',
        disabled: '#82ce9d',
        strong: {
          default: '#005d31',
        },
        weak: {
          default: '#0e9d5a',
        },
      },
      danger: {
        default: '#da030ae6',
        disabled: '#ffa991',
        strong: {
          default: '#a60000',
          disabled: '#ff7d61',
        },
        stronger: {
          default: '#7c0000',
        },
        weak: {
          default: '#f94830',
        },
      },
      warning: {
        default: '#A77D15',
        strong: {
          default: '#7D5E16',
        },
        weak: {
          default: '#FFC800',
        },
      },
      interactive: {
        default: '#1a62e9',
        hover: '#1948b2',
        press: '#1c347e',
        disabled: '#9fbeff',
        select: '#1948b2',
        inverse: {
          default: '#73a3ff',
          hover: '#9fbeff',
          press: '#c6d6ff',
          select: '#9fbeff',
          disabled: '#1a62e9',
        },
      },
      inverse: {
        default: '#f9fafb',
        hover: '#dce1e8',
        press: '#c1c7d0',
        disabled: '#4b5361',
        select: '#dce1e8',
        weak: {
          default: '#ebeef2',
        },
        weaker: {
          default: '#dce1e8',
        },
        weakest: {
          default: '#a2aab6',
        },
      },
      strong: {
        default: '#c1c7d0',
        disabled: '#e3e7ed',
        hover: '#878e9b',
      },
    },
    border: {
      global: {
        strong: {
          default: '#4b5361',
        },
        default: '#323841',
        transparent: {
          default: '#13161999',
        },
        inverse: {
          default: '#a2aab6',
        },
      },
      default: '#dce1e8',
      hover: '#a2aab6',
      press: '#878e9b',
      disabled: '#f6f7f9',
      strong: {
        default: '#878e9b',
      },
      strongest: {
        default: '#21262c',
      },
      weak: {
        default: '#e3e7ed',
        hover: '#c1c7d0',
        press: '#a2aab6',
        select: '#a2aab6',
        disabled: '#f6f7f9',
      },
      weaker: {
        default: '#ebeef2',
      },
      transparent: {
        weakest: {
          default: '#1316190d',
        },
        inverse: {
          default: '#ffffff1a',
        },
        weaker: {
          default: '#1316191a',
        },
        strong: {
          default: '#13161999',
        },
      },
      accent: {
        default: '#FAE000',
        weakest: {
          default: '#FDEF7F',
        },
      },
      informative: {
        default: '#1a62e9',
        weaker: {
          default: '#c6d6ff',
        },
        weakest: {
          default: '#e4ebff',
        },
      },
      success: {
        default: '#007c42',
        hover: '#005d31',
        press: '#034424',
        disabled: '#b2e1c1',
        weaker: {
          default: '#b2e1c1',
        },
        select: '#005d31',
        weakest: {
          default: '#dbf1e1',
        },
      },
      danger: {
        default: '#da030ae6',
        hover: '#a60000',
        press: '#7c0000',
        disabled: '#ffcbbb',
        weaker: {
          default: '#ffcbbb',
        },
        select: '#a60000',
        weakest: {
          default: '#ffe7df',
        },
      },
      warning: {
        default: '#A77D15',
        weaker: {
          default: '#FDEF7F',
        },
        weakest: {
          default: '#FFF7B1',
        },
      },
      inverse: {
        default: '#21262c',
      },
      select: '#a2aab6',
      weakest: {
        default: '#f6f7f9',
      },
      stronger: {
        default: '#323841',
      },
    },
    interactive: {
      strongest: {
        default: '#21262c',
        hover: '#4b5361',
        press: '#676f7d',
        disabled: '#dce1e8',
        select: '#323841',
      },
      danger: {
        default: '#da030ae6',
        hover: '#a60000',
        press: '#7c0000',
        disabled: '#ffa991',
        select: '#a60000',
      },
      weak: {
        default: '#dce1e8',
        hover: '#c1c7d0',
      },
      white: {
        default: '#ffffff',
        disabled: '#ffffffcc',
      },
      weaker: {
        default: '#ebeef2',
        disabled: '#f6f7f9',
      },
      default: '#c1c7d0',
      hover: '#878e9b',
      press: '#676f7d',
      disabled: '#ebeef2',
      weakest: {
        default: '#f6f7f9',
      },
      stronger: {
        default: '#323841',
        hover: '#676f7d',
        press: '#878e9b',
        select: '#4b5361',
        disabled: '#dce1e8',
      },
      global: {
        default: '#878e9b',
        hover: '#a2aab6',
        press: '#dce1e8',
        disabled: '#4b5361',
        weakest: {
          default: '#131619',
          disabled: '#21262c',
        },
        strongest: {
          default: '#ffffff80',
          hover: '#a2aab6',
          press: '#878e9b',
          disabled: '#323841',
        },
        danger: {
          default: '#da030ae6',
          hover: '#a60000',
          press: '#7c0000',
          disabled: '#510b00',
          select: '#a60000',
        },
        strong: {
          default: '#4b5361',
          hover: '#676f7d',
          press: '#878e9b',
          disabled: '#21262c',
        },
        weaker: {
          default: '#21262c',
        },
      },
    },
    actionSurface: {
      accent: {
        default: '#FAE000',
        hover: '#FFC800',
        press: '#EAAF09',
        select: '#FFC800',
      },
      primary: {
        default: '#21262c',
        hover: '#323841',
        press: '#4b5361',
        select: '#323841',
      },
      secondary: {
        default: '#ebeef2',
        hover: '#e3e7ed',
        press: '#dce1e8',
        select: '#e3e7ed',
      },
      tertiary: {
        default: '#ffffff',
        hover: '#f9fafb',
        press: '#f6f7f9',
        disabled: '#ffffff',
        select: '#f9fafb',
      },
      ghost: {
        hover: '#ebeef2',
        press: '#e3e7ed',
        strong: {
          default: '#1316190d',
          press: '#13161926',
          hover: '#1316191a',
          select: '#1316191a',
        },
        select: '#ebeef2',
      },
      ghostInverse: {
        hover: '#ffffff1a',
        press: '#ffffff26',
        select: '#ffffff1a',
      },
      danger: {
        default: '#da030ae6',
        hover: '#a60000',
        press: '#7c0000',
        disabled: '#ffcbbb',
        weak: {
          default: '#fff7f5',
          hover: '#ffe7df',
          press: '#ffcbbb',
          disabled: '#fff7f5',
          select: '#ffe7df',
        },
        select: '#a60000',
      },
      success: {
        default: '#007c42',
        hover: '#005d31',
        press: '#034424',
        disabled: '#b2e1c1',
        weakest: {
          default: '#f3faf5',
          hover: '#dbf1e1',
          press: '#b2e1c1',
          disabled: '#f3faf5',
          select: '#dbf1e1',
        },
        select: '#005d31',
      },
      informative: {
        default: '#1a62e9',
        hover: '#1948b2',
        press: '#1c347e',
        disabled: '#c6d6ff',
        weakest: {
          default: '#f6f8ff',
          hover: '#e4ebff',
          press: '#c6d6ff',
          disabled: '#f6f8ff',
          select: '#e4ebff',
        },
        select: '#1948b2',
      },
      tertiaryInverse: {
        default: '#ffffff26',
        hover: '#ffffff33',
        press: '#ffffff40',
        disabled: '#ffffff1a',
        select: '#ffffff33',
      },
      disabled: '#f6f7f9',
    },
    actionBorder: {
      accent: {
        default: '#FAE000',
        hover: '#FFC800',
        press: '#EAAF09',
        select: '#C89612',
      },
      primary: {
        hover: '#21262c',
        press: '#323841',
        select: '#21262c',
        default: '#21262c',
      },
      tertiary: {
        default: '#dce1e8',
        hover: '#878e9b',
        press: '#4b5361',
        disabled: '#ebeef2',
        select: '#878e9b',
      },
      danger: {
        default: '#da030ae6',
        hover: '#a60000',
        press: '#7c0000',
        weak: {
          default: '#ffcbbb',
          hover: '#ffa991',
          press: '#ff7d61',
          disabled: '#ffcbbb',
          select: '#ffa991',
        },
        select: '#a60000',
      },
      success: {
        default: '#007c42',
        hover: '#005d31',
        press: '#034424',
        weak: {
          default: '#b2e1c1',
          hover: '#82ce9d',
          press: '#4db779',
          disabled: '#b2e1c1',
          select: '#82ce9d',
        },
        select: '#005d31',
      },
    },
    focusRing: {
      default: '#131619',
      inverse: '#ffffff',
    },
    decorativeSurface: {
      purple: '#b692f3',
      magenta: '#ff76a6',
      sky: '#4aace8',
      teal: '#57b2b0',
      blue: '#73a3ff',
      green: '#4db779',
      red: '#ff7d61',
      orange: '#ffac61',
      yellow: '#FFC800',
      weaker: {
        purple: '#f1e8fc',
        magenta: '#ffe6ee',
        sky: '#deeefd',
        teal: '#dcefee',
        blue: '#e4ebff',
        green: '#dbf1e1',
        orange: '#ffe7d3',
        red: '#ffe7df',
        yellow: '#FFF7B1',
      },
      weakest: {
        purple: '#f9f6fe',
        magenta: '#fff4f7',
        sky: '#f4f9fe',
        blue: '#f6f8ff',
        teal: '#f4f9f9',
        green: '#f3faf5',
        red: '#fff7f5',
        orange: '#fff6ef',
        yellow: '#FFFCE5',
      },
      strong: {
        purple: '#9d6bff',
        magenta: '#f44289',
        sky: '#0091cf',
        teal: '#1c9896',
        blue: '#3e85ff',
        green: '#0e9d5a',
        red: '#f94830',
        orange: '#ff8115',
        yellow: '#C89612',
      },
      stronger: {
        purple: '#7646f8',
        magenta: '#d0146c',
        sky: '#0072a6',
        teal: '#007977',
        blue: '#1a62e9',
        green: '#007c42',
        red: '#da030ae6',
        orange: '#de6603',
        yellow: '#A77D15',
      },
      strongest: {
        purple: '#552ec9',
        magenta: '#9f0651',
        sky: '#00557c',
        teal: '#005a59',
        blue: '#1948b2',
        green: '#005d31',
        red: '#a60000',
        orange: '#b05007',
        yellow: '#7D5E16',
      },
      weak: {
        purple: '#e1cefa',
        magenta: '#ffc8d9',
        sky: '#b4dafb',
        teal: '#b5dedc',
        blue: '#c6d6ff',
        green: '#b2e1c1',
        orange: '#ffcca2',
        red: '#ffcbbb',
        yellow: '#FDEF7F',
      },
    },
    decorativeText: {
      purple: '#552ec9',
      magenta: '#9f0651',
      sky: '#00557c',
      teal: '#005a59',
      blue: '#1948b2',
      green: '#005d31',
      red: '#a60000',
      orange: '#b05007',
      yellow: '#7D5E16',
      weak: {
        purple: '#7646f8',
        magenta: '#d0146c',
        sky: '#0072a6',
        teal: '#007977',
        blue: '#1a62e9',
        green: '#007c42',
        red: '#da030ae6',
        orange: '#de6603',
        yellow: '#A77D15',
      },
      weakest: {
        purple: '#b692f3',
        magenta: '#ff76a6',
        sky: '#4aace8',
        teal: '#57b2b0',
        blue: '#73a3ff',
        green: '#4db779',
        red: '#ff7d61',
        orange: '#ff8115',
        yellow: '#FFC800',
      },
    },
    decorativeIcon: {
      purple: '#552ec9',
      magenta: '#9f0651',
      sky: '#00557c',
      teal: '#005a59',
      blue: '#1948b2',
      green: '#005d31',
      red: '#a60000',
      orange: '#b05007',
      yellow: '#7D5E16',
      weakest: {
        purple: '#b692f3',
        magenta: '#ff76a6',
        sky: '#4aace8',
        teal: '#57b2b0',
        blue: '#73a3ff',
        green: '#4db779',
        red: '#ff7d61',
        orange: '#ff8115',
        yellow: '#FFC800',
      },
      weak: {
        purple: '#7646f8',
        magenta: '#d0146c',
        sky: '#0072a6',
        teal: '#007977',
        blue: '#1a62e9',
        green: '#007c42',
        red: '#da030ae6',
        orange: '#de6603',
        yellow: '#A77D15',
      },
    },
    decorativeBorder: {
      purple: '#e1cefa',
      magenta: '#ffc8d9',
      sky: '#b4dafb',
      teal: '#b5dedc',
      blue: '#c6d6ff',
      green: '#b2e1c1',
      red: '#ffcbbb',
      orange: '#ffcca2',
      yellow: '#FDEF7F',
      strong: {
        purple: '#7646f8',
        magenta: '#d0146c',
        sky: '#0072a6',
        teal: '#007977',
        blue: '#1a62e9',
        green: '#007c42',
        red: '#da030ae6',
        orange: '#de6603',
        yellow: '#C89612',
      },
    },
    surfaceElevation: {
      default: '#13161926',
    },
    chart: {
      default: {
        '1': '#0091cf',
        '2': '#de6603',
        '3': '#1c9896',
        '4': '#EAAF09',
        '5': '#9d6bff',
        '6': '#f44289',
        '7': '#3e85ff',
        '8': '#0e9d5a',
        '9': '#ff7d61',
      },
      weakest: {
        '1': '#b4dafb',
        '2': '#ffcca2',
        '3': '#b5dedc',
        '4': '#FDEF7F',
        '5': '#e1cefa',
        '6': '#ffc8d9',
        '7': '#c6d6ff',
        '8': '#b2e1c1',
        '9': '#ffe7df',
      },
      weak: {
        '1': '#4aace8',
        '2': '#ff8115',
        '3': '#57b2b0',
        '4': '#FFC800',
        '5': '#b692f3',
        '6': '#ff76a6',
        '7': '#73a3ff',
        '8': '#4db779',
        '9': '#ffa991',
      },
      strong: {
        '1': '#0072a6',
        '2': '#b05007',
        '3': '#007977',
        '4': '#C89612',
        '5': '#7646f8',
        '6': '#d0146c',
        '7': '#1a62e9',
        '8': '#007c42',
        '9': '#a60000',
      },
      neutral: {
        weak: '#e3e7ed',
        default: '#c1c7d0',
        strong: '#878e9b',
      },
    },
  },
  spacing: {
    '2': '2px',
    '4': '4px',
    '6': '6px',
    '8': '8px',
    '10': '10px',
    '12': '12px',
    '16': '16px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '40': '40px',
    '48': '48px',
    '56': '56px',
    '64': '64px',
    '72': '72px',
    '80': '80px',
    '96': '96px',
    '112': '112px',
    '128': '128px',
    '160': '160px',
  },
  borderRadius: {
    '1': '1px',
    '2': '2px',
    '4': '4px',
    '6': '6px',
    '8': '8px',
    '10': '10px',
    '12': '12px',
    '16': '16px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '40': '40px',
    '99': '99px',
  },
  borderWidth: {
    '1': '1px',
    '2': '2px',
    '3': '3px',
    '4': '4px',
    '6': '6px',
    '8': '8px',
    '12': '12px',
  },
  elevation: {
    level_1: '0px 1px 2px 0px #13161926, 0px 0px 1px 0px #13161926',
    level_2: '0px 3px 6px 0px #13161926, 0px 0px 1px 0px #13161926',
    level_3: '0px 0px 8px 0px #13161926',
    level_4: '0px 0px 1px 0px #13161926, 0px 4px 8px 0px #13161926',
    level_5: '0px 8px 16px 0px #13161926, 0px 0px 2px 0px #13161926',
    level_6: '0px 8px 16px 0px #13161926',
  },
  fontFamilies: {
    base: 'Pretendard',
    code: 'SF Mono',
  },
  fontWeights: {
    '400': 400,
    '500': 500,
    '600': 600,
    '700': 700,
  },
  lineHeights: {
    '130': '130%',
    '150': '150%',
    '175': '175%',
  },
  fontSize: {
    '11': 11,
    '12': 12,
    '13': 13,
    '14': 14,
    '16': 16,
    '18': 18,
    '20': 20,
    '24': 24,
    '28': 28,
    '32': 32,
    '40': 40,
    '48': 48,
  },
  letterSpacing: {
    '0': '0%',
  },
  paragraphSpacing: {
    '0': 0,
  },
  textCase: {
    none: 'none',
  },
  textDecoration: {
    none: 'none',
    underline: 'underline',
  },
  paragraphIndent: {
    '0': '0px',
  },
  breakpoint: {
    margin: {
      lg: '32px',
      md: '32px',
      sm: '24px',
    },
    gutter: {
      lg: '16px',
      md: '16px',
      sm: '12px',
    },
    minWidth: {
      lg: '1920px',
      md: '1280px',
      sm: '800px',
    },
    maxWidth: {
      lg: '9999px',
      sm: '1279px',
      md: '1919px',
    },
  },
  heading: {
    bold: {
      '7xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 48,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '6xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 40,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '5xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 32,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '4xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 28,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '3xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 24,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xl': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 20,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    semibold: {
      '7xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 48,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '6xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 40,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '5xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 32,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '4xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 28,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '3xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 24,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xl': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 20,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
  },
  label: {
    bold: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xs': {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        lineHeight: '150%',
        fontSize: 11,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    semibold: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xs': {
        fontFamily: 'Pretendard',
        fontWeight: 600,
        lineHeight: '150%',
        fontSize: 11,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    medium: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xs': {
        fontFamily: 'Pretendard',
        fontWeight: 500,
        lineHeight: '150%',
        fontSize: 11,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    regular: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      '2xs': {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 11,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    regularUnderline: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
      '2xs': {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 11,
        letterSpacing: '0%',
        textDecoration: 'underline',
      },
    },
  },
  body: {
    normal: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    compact: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '130%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '130%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '130%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '130%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '130%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    loose: {
      xl: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 18,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      lg: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
  },
  code: {
    normal: {
      lg: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '150%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
    loose: {
      lg: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 16,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      md: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 14,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      sm: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 13,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
      xs: {
        fontFamily: 'SF Mono',
        fontWeight: 400,
        lineHeight: '175%',
        fontSize: 12,
        letterSpacing: '0%',
        textDecoration: 'none',
      },
    },
  },
};
export default foundation;
